<div #mapContainer class="maplibre-container maplibre-outlets-accordion"></div>
